import React from "react";
import classNames from "classnames";
import { format, parseISO } from "date-fns";
import { Amount } from "@design-system/Amount/Amount";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useEntitiesById } from "@hooks/useEntities";
import { IntercompanyMatchContext } from "./intercompanyTransactions.lib";
import styles from "./IntercompanyTransactionsTable.module.scss";

interface IntercompanyComputedMatchPreviewProps {
    matchContext: IntercompanyMatchContext;
}

export const IntercompanyComputedMatchPreview = React.memo(
    function IntercompanyComputedMatchPreview({
        matchContext,
    }: IntercompanyComputedMatchPreviewProps): React.ReactElement {
        const entity = useEntitiesById().get(matchContext.entityId);
        const formattedDate = matchContext.date
            ? format(parseISO(matchContext.date), "MMM d")
            : null;

        return (
            <div className={styles.matchPreview}>
                <span className={styles.matchDate}>
                    {formattedDate ?? <EmptyValue />}
                </span>
                <span className={styles.matchAccount}>
                    {matchContext.accountLabel.trim() === "" ? (
                        <EmptyValue />
                    ) : (
                        matchContext.accountLabel
                    )}
                </span>
                <div
                    className={classNames(
                        "transaction-amount",
                        "transaction-amount--color",
                        {
                            "transaction-amount--credit":
                                matchContext.amount > 0,
                            "transaction-amount--debit":
                                matchContext.amount < 0,
                        },
                        styles.matchAmount,
                    )}
                >
                    <Amount amount={matchContext.amount} showNegative />
                </div>
                {entity ? (
                    <EntityAvatar
                        entity={entity}
                        className={styles.matchEntity}
                        size="xs"
                    />
                ) : null}
            </div>
        );
    },
);
